import dashboard from "../../../assets/img/dashboard1.svg"
import user from "../../../assets/img/user1.svg"
import company from "../../../assets/img/company1.svg"


export const menuCore = [
  {
    url: "/admin/core-management/dashboard",
    icon: dashboard,
    title: "Dashboard",
    description: "Get a quick overview of platform activity and performance metrics",
  },
  {
    url: "/admin/core-management/user",
    icon: user,
    title: "Users",
    description: "Manage user accounts, roles, and permissions",
  },
  {
    url: "/admin/core-management/company",
    icon: company,
    title: "Companies",
    description: "Handle organization profiles and company-specific settings",
  },
]